import script from "./ConstructorTemplate.vue?vue&type=script&setup=true&lang=js"
export * from "./ConstructorTemplate.vue?vue&type=script&setup=true&lang=js"

import "./ConstructorTemplate.vue?vue&type=style&index=0&id=f18dbd60&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f18dbd60"]])

export default __exports__